import L from "leaflet";
import "leaflet-rotatedmarker";
import "leaflet/dist/leaflet.css";
import React, { useEffect, useRef } from "react";
import { Marker, Tooltip } from "react-leaflet";
import { flightStatus } from "../../../../models/airports/AirportConfig";
import { tooltipStyles } from "../../map-displays/mapStyles";
import { getFlightIcon } from "../marker-icons/flightIcons";
import FlightMarkerTooltip from "./FlightMarkerTooltip";

export interface IFlightMarkerProps {
  id: string;
  airportCode: string;
  flightNumber: string;
  position: [number, number];
  direction: number;
  flightStatus: flightStatus;
  legType: string;
  selectedFlight: boolean;
  docID: string;
  pane?: string;
  acType?: string;
  acReg?: string;
  onBlockTime?: string;
  offBlockTime?: string;
  updateMarkerId: (flightID: string, docId: string) => void;
}

const FlightMarker: React.FC<IFlightMarkerProps> = ({
  airportCode,
  flightNumber,
  position,
  flightStatus = "default",
  direction,
  legType,
  selectedFlight,
  docID,
  pane = "",
  acType,
  acReg,
  onBlockTime,
  offBlockTime,
  updateMarkerId,
}) => {
  const markerRef = useRef(null);
  const tooltipClasses = tooltipStyles();

  useEffect(() => {
    if (markerRef.current) {
      const currentMarker = markerRef.current as L.Marker;
      currentMarker.setLatLng(position);
      currentMarker.setRotationAngle(direction - 90);
    }
  }, [position, direction]);

  const onHandleMarkerClick = () => {
    updateMarkerId(flightNumber, docID);
  };

  return (
    <Marker
      pane={pane}
      position={position}
      icon={getFlightIcon(flightStatus, selectedFlight)}
      ref={markerRef}
      eventHandlers={{ click: onHandleMarkerClick }}
    >
      <Tooltip
        direction="top"
        className={tooltipClasses.tooltip}
        pane="flight-tooltip-pane"
      >
        <FlightMarkerTooltip
          flightNumber={flightNumber}
          airportCode={airportCode}
          legType={legType}
          acType={acType}
          acReg={acReg}
          onBlockTime={onBlockTime}
          offBlockTime={offBlockTime}
        />
      </Tooltip>
    </Marker>
  );
};

export default FlightMarker;
